import { LatLng } from "../model/viewModel/simpleTypes";

/**
 * Validates if a coordinate object has valid lat/lng values
 */
export const isValidCoordinate = (coord: LatLng) => {
  if (!coord) return false;

  return (
    typeof coord.lat === "number" &&
    typeof coord.lng === "number" &&
    !isNaN(coord.lat) &&
    !isNaN(coord.lng)
  );
};

/**
 * Check if two LatLng values are equal
 */
export const coordinatesAreEqual = (
  coord1: LatLng | null | undefined,
  coord2: LatLng | null | undefined,
  precision: number = 1e-9,
): boolean => {
  if (!coord1 && !coord2) return true;
  if (!coord1 || !coord2) return false;

  if (!isValidCoordinate(coord1) || !isValidCoordinate(coord2)) return false;

  return (
    Math.abs(coord1.lat - coord2.lat) < precision && Math.abs(coord1.lng - coord2.lng) < precision
  );
};

/**
 * Push a coordinate onto an array only if it is different from the last coordinate
 */
export const pushCoordinateIfNew = (
  coordArray: LatLng[] | null | undefined,
  coord: LatLng,
): LatLng[] => {
  const safeArray = coordArray ?? [];
  const lastPoint = safeArray.length > 0 ? safeArray[safeArray.length - 1] : null;

  if (coordinatesAreEqual(lastPoint, coord)) {
    return safeArray;
  }

  return [...safeArray, coord];
};
